const mutation = {
  SET_WALLET(state, list) {
    state.walletList = list;
  },

  SET_WALLET_LOADING(state, status) {
    state.isLoading = status;
  },
  SET_WALLET_LIST(state, list) {
    state.list = list;
  },

  SET_WALLET_LIST_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_WALLET_TRANSPORTER_LIST_LOADING(state, status) {
    state.isTransporterListLoading = status;
  },

  SET_WALLET_TRANSPORTER_LIST(state, list) {
    const result = (state.page > 1) ? state.transporterWallet.concat(list) : list;
    state.transporterWallet = result;
    if (list.length) {
      state.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  SET_PAGE(state, data) {
    state.page = data;
  },

  initData(state) {
    state.page = 1;
    state.hasEmpty = false;
    state.list = [];
    state.walletList = [];
  },

};

export default mutation;
